import { getErrorMessage } from "@lifeat/shared/error/ErrorUtil";
import { userTaskDataCollection } from "@lifeat/shared/task-management/TaskManagementTypes";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import useOnUserDataLoaded from "@hooks/useOnUserDataLoaded";
import { FirestoreService } from "@service/FirestoreService";
import { isTodoListDataMigrationProcessing$ } from "./TaskManagementGlobals";
import { TaskManagementService } from "./TaskManagementService";

export const useTaskMigration = () => {
    const fs = FirestoreService();

    const { user }: UserContextType = useUserContext();

    // Trigger migration of todo list data to task list.
    useOnUserDataLoaded((loadedUserData) => {
        if (loadedUserData?.todoListData == null) {
            // No legacy todo list data to migrate.
            return;
        }
        if (user?.uid) {
            const node = userTaskDataCollection.at(user.uid).at("tasks").node;
            fs.getCollection(node).then((data) => {
                if (data == null || Object.keys(data).length === 0) {
                    const attemptMigrate = async () => {
                        isTodoListDataMigrationProcessing$.value = true;
                        const data = await fs.getDocument(userTaskDataCollection.at(user.uid).node);
                        if (data == null) {
                            try {
                                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                                await TaskManagementService.migrateTaskData2023(timezone);
                            } catch (err) {
                                throw err;
                            }
                        }
                    };

                    attemptMigrate()
                        .then(() => {
                            isTodoListDataMigrationProcessing$.value = false;
                        })
                        .catch((err) => {
                            isTodoListDataMigrationProcessing$.value = false;
                            alert(
                                `There was an error migrating your todo list data. ` +
                                    `Please contact LifeAt support.\n\nError: ${getErrorMessage(err)}`,
                            );
                        });
                }
            });
        }
    });
};
